import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow\">\n    <title>icon/基础图标/箭头</title>\n    <g id=\"icon-arrow_icon/基础图标/箭头\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" stroke-linejoin=\"round\">\n        <polyline id=\"icon-arrow_路径备份-2\" stroke=\"currentColor\" stroke-width=\"10\" transform=\"translate(38.6802, 47.8198) rotate(-315) translate(-38.6802, -47.8198)\" points=\"18.3015152 27.4411255 56.2526951 29.5401981 59.0588745 68.1984848\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow.svg
// module id = nCIC
// module chunks = 3